import * as routes from 'client/routes/manifest';
import { AppContent } from 'content/AppContent';

import { MetaContentValues } from '../metaContentValues';

const landlordSupport: AppContent['landlordSupport'] = {
  metaContent: MetaContentValues.landlordSupport,
  pageTitle: 'Landlord guidance',
  bannerStrongText:
    "When you're a landlord, there are certain things you have to do by law. These include making sure your property meets all relevant regulations before you rent it out and knowing what your financial obligations are. You must also make sure you understand your tenants' rights while you rent it out.",
  bannerText:
    'If you use a letting agent to rent out your property, they can help you with most of the things on this page.',
  navigationTiles: [
    {
      linkText: 'Legal responsibilities',
      boxText:
        "Understand what your legal responsibilities are when you're a landlord.",
      url: routes.LegalResponsibilities,
    },
    {
      linkText: 'Making repairs',
      boxText:
        'What are your responsibilities when it comes to making repairs as a landlord?',
      url: routes.MakingRepairs,
    },
    {
      linkText: 'Rent increases',
      boxText:
        'This is never an easy thing to tackle. Understand how to do it in the right way.',
      url: routes.RentIncreases,
    },
    {
      linkText: 'Tenant disputes',
      boxText:
        'Sometimes things can go wrong, and you might end in a dispute with your tenant. So, what are your options?',
      url: routes.TenantDisputes,
    },
    {
      linkText: 'Houses in Multiple Occupation (HMO)',
      boxText: 'What you need to know about renting out HMOs.',
      url: routes.HousesInMultipleOccupation,
    },
    {
      linkText: 'Paying tax and National Insurance',
      boxText:
        'You might have to pay tax and National Insurance on your rental income.',
      url: routes.PayingTaxAndNationalInsurance,
    },
    {
      linkText: 'Landlord insurance',
      boxText:
        "As a landlord it's important to make sure you've got everything covered.",
      url: routes.LandlordInsurance,
    },
    {
      linkText: 'Professional landlord help',
      boxText: 'Understand what to look for when you need some expert support.',
      url: routes.ProfessionalLandlordHelp,
    },
    {
      linkText: 'Landlord associations',
      boxText:
        "Belonging to an association might help you. Take a look at what's on offer with each one.",
      url: routes.LandlordAssociations,
    },
    {
      linkText: 'The Renters Rights Bill',
      boxText:
        "Belonging to an association might help you. Take a look at what's on offer with each one.",
      url: routes.RentersRightsBill,
    },
  ],
};

export default landlordSupport;
